// NOW PLAYING
export const FETCH_MOVIES_NOW_PLAYING = "FETCH_MOVIES_NOW_PLAYING";

// MOVIE
export const CHANGE_CURRENT_CATEGORY = "CHANGE_CURRENT_CATEGORY"
export const CHANGE_CURRENT_CATEGORY_MOVIES = "CHANGE_CURRENT_CATEGORY_MOVIES"
export const FETCH_MOVIES_BY_POPULAR = "FETCH_MOVIES_BY_POPULAR"